import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog, MatDialogRef, MatPaginator, MatSort, MatTableDataSource, MatChipInputEvent, MatAutocompleteSelectedEvent } from '@angular/material';
import { DefaultCostValuesModel, SolutionDescriptionNodes } from '../../models/index';
import { Subscription } from 'rxjs/Subscription';
import { ActivatedRoute } from '@angular/router';
import * as _ from 'lodash';
import { fuseAnimations } from '../../../../../core/animations';

//Pipe
import { FiveDigitRandomNumberPipe } from '../../pipesFiles/randomNumber.pipe';
import { FirstLinePipe } from '../../pipesFiles/firstLine.pipe';
//Service file
import { EcommerceOrdersService } from '../orders/orders.service';
import { SolutionFormService } from '../solutionForm/solutionForm.service';
import { SideNavService } from '../orders/sidenavs/sidenav.service';
//Query File 
import { BookingsQueryService, SolutionMasterQueryService } from '../../queryFiles/index';
//Common File 
import { checkoutFields, itemsPerPageForPopulate, orders, paginationForItemsPopulate, requestedWorkPage, spekwoType, toastMsg, toolTip, spekwo } from '../../utils/index';
//Dialog File 
import { FuseConfirmDialogComponent } from '../../../../../core/components/confirm-dialog/confirm-dialog.component';
import { ConfirmDialogComponent } from '../solutionForm/confirm-dialog/confirm-dialog.component';
//Toast Component 
import { ToastComponent } from '../../common/toast.component';
import { CommonOrdersService } from '../orders/commonOrders.service';
import { AuditHistoryService } from '../../../../../core/services/audit-history.service';



@Component({
    selector: 'app-common-save-table',
    templateUrl: './common-save-table.component.html',
    styleUrls: ['./common-save-table.component.scss'],
    animations: fuseAnimations,
    encapsulation: ViewEncapsulation.None,
    providers: [
        FiveDigitRandomNumberPipe,
        FirstLinePipe
    ]
})
export class CommonSaveTableComponent implements OnInit {

    @Input() pageType: string;
    @Input() scheduleDateByClient: string;
    @Input() buyerPropertyAddress: string;
    @Output() tableLoad = new EventEmitter<{ flag: any }>();
    @Input() nodeId: string;
    @Input() enable: any;
    @Input() items: any = [];
    @Input() picturesDetails: any;
    @Input() productType: any;
    @Input() isAllowed: boolean;
    @Input() solView: string;
    allStatus: OrderStatus[];

    @ViewChild('fieldPaginator') fieldPaginator: MatPaginator;

    confirmDialogRef: MatDialogRef<FuseConfirmDialogComponent>;
    emailConfirmRef: MatDialogRef<ConfirmDialogComponent>;


    //const file 
    spekwoType = spekwoType;
    toolTip = toolTip;
    toastMsg = toastMsg;
    requestedWorkPage = requestedWorkPage;
    orders = orders;
    spekwo = spekwo;

    //table 
    newAttribute: InitialData = <InitialData>{};
    fieldArray: Array<any> = [];
    fieldDataSource: MatTableDataSource<fieldArrayData>;
    beforeTotalCost: number = 0; // total cost before saving
    enableSave: boolean = false;
    selectedTableIndex: number;
    defaultValue: DefaultCostValuesModel = defaultCostInitialValues;


    bodySpinner: boolean = false;/**Spinner */
    // pagination 
    itemsPerPage: number;//Items per page in paginator
    pagination = paginationForItemsPopulate;
    initalLoad = itemsPerPageForPopulate; //Initial data load per page
    page: number = 1;
    selectedIndex: number = 0; //To find drag index to highlight row
    itemsPerPageForReports: number;//Items per page in paginator
    pageNumberForReports: number;
    pageNumber: number;// for which page we are currently in

    costOptionType = 'create';
    selectedCostOption: string = '';

    matchedResult = []; // Return matched result
    tmCostOption: string[] = ['tm', 'Flat', 'foot'];
    addtoDbLoader: boolean = false;

    //Drag 
    dragIndex: number; // for identifying dragIndex based on paginator value
    dragIndexForReports: number;
    insReportId: string;

    private _subscriptions: Subscription[] = [];
    currentOrderId: number;
    lastReviewId: any;

    searchKeyWordsList = []; // Serached input
    cost = [];

    public userRole: any;
    data: any;
    itemsNumber: any = [];
    filterItems: any;
    checkoutFields = checkoutFields;
    titleShow: boolean = false;
    filterPictureDetails: any;
    pictureItems: any = [];
    decriptionList: any = [];
    roleId: any;
    userId: any;

    cancleWorkConst = cancelConst.cancleWorkConst;

    constructor(
        private dialog: MatDialog,
        private pipe: FiveDigitRandomNumberPipe,
        private _sideNavService: SideNavService,
        private formService: SolutionFormService,
        private solutionFormService: SolutionFormService,

        /** Local component */
        private toastComponent: ToastComponent,
        private route: ActivatedRoute,
        private bookingsQueryService: BookingsQueryService,
        public solutionMasterQueryService: SolutionMasterQueryService,
        public ecommerceOrdersService: EcommerceOrdersService,
        public commonOrdersService: CommonOrdersService,
        public auditHistoryService: AuditHistoryService,
    ) {
        this.newAttribute = Object.assign({}, initialValues);
        this.userRole = window.localStorage.getItem('role');
        this.roleId = window.localStorage.getItem("roleId");
        this.userId = window.localStorage.getItem('userUID');
    }

    ngOnInit() {
        this.evaluateAndProceed();
        console.log("pageType", this.pageType)
    }

    // proceed flow
    evaluateAndProceed() {
        this.pictureItems = [];
        this.itemsNumber = [];
        this.decriptionList = [];
        this.fieldArray = [];
        this.commonOrdersService.listOfStatus.subscribe((statusRes) => {
            this.allStatus = statusRes.length > 0 ? statusRes : [];
        });
        if (this.picturesDetails && this.picturesDetails.length > 0) {
            this.picturesDetails.forEach((items) => {
                if (items.id) {
                    this.pictureItems.push(items.id.toString());  // store pictures items numbers 
                }

                this.decriptionList.push(items.description) // store pictures descriptions
            });
        }

        this.beforeTotalCost = 0; // total cost before saving
        this.cost = [];

        this.pageNumber = 1;// initially set to 1st page
        this.itemsPerPage = this.initalLoad; // initally set to initial value
        this.dragIndex = 0; //initially set to 0

        this.pageNumberForReports = 1;
        this.dragIndexForReports = 0;

        //get Inspection report  id.
        this._subscriptions.push(this.formService.insReportIdChange.subscribe(data => {
            this.insReportId = data && data.insReportId;
        }));

        // get current order from params
        this.route.params.subscribe(params => {
            this.currentOrderId = Number.parseInt(params.id);
        });

        this.autoPrePopulatedItems();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes && changes.picturesDetails && !changes.picturesDetails.firstChange && changes.picturesDetails.currentValue) {
            this.evaluateAndProceed();
        }

        if (changes && changes.solView && changes.solView.currentValue && (changes.solView.currentValue === 'onSave' || changes.solView.currentValue === 'multipleRows')) {
            this.addFieldValue(changes.solView.currentValue);
        }
    }

    autoPrePopulatedItems() {
        if (this.pageType == 'solutionEstimatePage' && this.items && this.items.length > 0) { //. additionaly check product
            this.prePopulate(this.currentOrderId, this.items, this.picturesDetails, this.decriptionList)
        }
        else if (this.pageType == 'solutionEstimatePage' && this.pictureItems && this.pictureItems.length > 0) {
            this.prePopulate(this.currentOrderId, this.pictureItems, this.picturesDetails, this.decriptionList)
        }
    }

    prePopulate(currentOrderId, itemsNumber, picturesDetails, decriptionList) {
        this.formService.fliterItemsFromSolution(currentOrderId, itemsNumber).then((response: any) => {
            let filterItems = response && response.data && response.data.allReportReviewDetails && response.data.allReportReviewDetails.nodes.length > 0 && response.data.allReportReviewDetails.nodes ? response.data.allReportReviewDetails.nodes : null;
            if (filterItems) {
                // let index = 0; 
                // console.log("filterItems",filterItems);

                // itemsNumber.forEach((item,key )=> { 
                //     let check =_.filter(filterItems ,event =>{
                //         return event.categoryName == item;
                //     });
                //     console.log("check",check);
                //     if(check && check.length == 0){
                //         this.titleShow = true ;
                //         this.addFieldValue('onSave');
                //         this.fieldArray[index].categoryNo= item; 
                //         if(picturesDetails && picturesDetails.length > 0){
                //             picturesDetails.forEach(picturesDetail => {
                //                 if(picturesDetail.id == item ){
                //                      this.fieldArray[index].description= picturesDetail.description; 
                //                 }
                //             });
                //         }
                //         index++;
                //     }
                // });
            }
            else {
                if (itemsNumber.length > 0) {
                    this.titleShow = true;
                    itemsNumber.forEach((item, key) => {
                        this.addFieldValue('onSave');
                        this.fieldArray[key].categoryNo = item
                        if (decriptionList && decriptionList.length > 0) {
                            this.fieldArray[key].description = this.decriptionList[key];
                        }
                    });
                }
            }
        }).catch((err) => {
            console.log('err', err);
        });
    }

    //Add selected categories on array
    addFieldValue(type) {
        var result = _.isEqual(this.newAttribute, initialValues);
        if (!result) {
            //Remove empty object in array before adding new one
            this.fieldArray = this.fieldArray.filter(value => Object.keys(value).length !== 0);
            this.fieldArray.push(this.newAttribute);
            this.fieldDataSource = new MatTableDataSource(this.fieldArray);
            this.fieldDataSource.paginator = this.fieldPaginator;
            this.selectedCost('');
        }
        initialValues.searchKeyWords = [];
        this.newAttribute = Object.assign({}, initialValues);
        this.refreshCategoryValue(this.fieldArray, type);
    }

    //to calculate totalcost
    selectedCost(value) {
        this.beforeTotalCost = 0;
        //for single row when field array is empty
        if (this.fieldArray.length == 0) {
            if (value) {
                this.beforeTotalCost = value;
            } else { //Newly added - to update totalsot after choose from keyword
                this.beforeTotalCost = this.newAttribute.totalCost;
            }
        }
        //if fieldarray length > 0
        else {
            var flag = 0;
            if (flag == 0) {
                flag = 1;
                this.fieldArray.forEach(data => {
                    if (data.totalCost) {
                        this.beforeTotalCost = Number(this.beforeTotalCost) + Number(data.totalCost);
                    }
                })
            }
        }
    }

    //check value is already stored
    refreshCategoryValue(value, type) {

        //for adding single row
        if (type === 'onSave') {
            this.enableSave = false;
            initialValues.searchKeyWords = [];
            //ADD empty object in array to display empty row fields
            this.fieldArray = this.fieldArray.concat(Object.assign({ randomNum: this.pipe.generateNumber() }, initialValues));
            this.fieldDataSource = new MatTableDataSource(this.fieldArray);
            this.fieldDataSource.paginator = this.fieldPaginator;
        }
        //for adding multiple rows
        if (type === 'multipleRows') {
            //ADD empty object in array to display empty row fields
            for (var i = 0; i < 10; i++) {
                initialValues.searchKeyWords = [];
                this.fieldArray = this.fieldArray.concat(Object.assign({ randomNum: this.pipe.generateNumber() }, initialValues));
            }
            this.enableSave = false;
            this.fieldDataSource = new MatTableDataSource(this.fieldArray);
            this.fieldDataSource.paginator = this.fieldPaginator;
        } else {
            this.fieldDataSource = new MatTableDataSource(this.fieldArray);
            //then load new data -But paginator lmit not working this
            this.fieldDataSource.paginator = this.fieldPaginator;
        }

    }

    initialDrag(index, randomNum) { //dragstart -before Review reoprts

        this.selectedIndex = randomNum;
    }

    //For input(onchange function)
    getInputValue(value) {
        this.enableSaveonCheck();
    }

    //Checking if category field is empty or not
    enableSaveonCheck() {
        var flag = true;
        if (this.fieldArray.length > 0) {

            this.fieldArray.forEach(data => {
                if (data.categoryNo.length > 0) {
                    flag = true;
                }
            });

        } else {
            flag = (this.newAttribute.categoryNo.length > 0) ? true : false;
        }

        this.enableSave = (flag) ? true : false;
    }


    //Assigning estimate table values 
    viewEstimateTable(index: number, type?: string) {
        this.selectedTableIndex = index;

        _.map(this.defaultValue, (value, key) => {
            this.defaultValue[key] = this.fieldArray[index][key];
        });

        this.costOptionType = 'edit'
        this.selectedCostOption = this.fieldArray[index].costOption;
        if (type == 'view') {
            this.scrollToCostEstimationTable();
        }

    }

    //Scroll to cost estimation table
    scrollToCostEstimationTable() {
        const contentContainer = document.getElementById('costEstimateTable');
        contentContainer.scrollIntoView();
    }

    setSelectedRow(index?: number) {
        this.selectedTableIndex = index;
    }



    // Cost selection dropdown
    costSelection(selected: string, index?: number) {
        if (this.fieldArray.length == 0) {
            this.newAttribute.costOption = selected;
            this.selectedCostOption = selected;
            this.costOptionType = 'create';
        }
        else {
            this.fieldArray[index].costOption = selected;
            this.selectedCostOption = selected;
            this.selectedTableIndex = index;
            this.costOptionType = 'create';
            if (this.tmCostOption.includes(selected)) {
                this.scrollToCostEstimationTable();
            }
        }
    }

    // Once drop refresh index
    onDropDataSuccess() {
        // this.selectedIndex = -1;
        this.selectedIndex = 0;
    }

    //Updating && creating solution description
    storingKeywordsInDB(index?: number) {
        this.addtoDbLoader = true;
        var solutions: any = (this.fieldArray.length > 0) ? this.fieldArray[index] : this.newAttribute;
        //Checking solutions is already existed or not
        this._sideNavService.checkSolutionDescriptionExited(solutions).then((res: SolutionDescriptionNodes[]) => {

            if (res.length > 0) {//if the solution existed
                this.addtoDbLoader = false;
                this.toastComponent.showToast(this.toastMsg.uploadSolutionDescriptionExisted);
            } else {//if not existed
                this._sideNavService.CreateSolutionDescriptionOnDb(solutions).then((res) => {
                    this.toastComponent.showToast(this.toastMsg.uploadSolutionDescriptionSuccess);
                    this.addtoDbLoader = false;
                });
            }
        }).catch((err) => {
            this.addtoDbLoader = false;
            this.toastComponent.showToast(this.toastMsg.uploadCompanyLogoFailed);
        });


    }

    //Remove a row from estimation table
    removeEntry(removeRow, removeIndex) {


        this.confirmDialogRef = this.dialog.open(FuseConfirmDialogComponent, {
            disableClose: false
        });

        this.confirmDialogRef.componentInstance.confirmMessage = this.toastMsg.deleteCategoryConfirm;
        this.confirmDialogRef.componentInstance.confirmHead = this.toastMsg.deleteCategoryHead;
        this.confirmDialogRef.componentInstance.confirmOkText = this.toastMsg.deleteCategoryOk;
        this.confirmDialogRef.componentInstance.confirmCancelText = this.toastMsg.deleteCategoryCancel;

        this.confirmDialogRef.afterClosed().subscribe(result => {

            if (result) {

                this.fieldArray = _.pull(this.fieldArray, removeRow);
                //If removed,then 'Repair replace value populated in dropdown
                this.refreshCategoryValue(this.fieldArray, 'onRemove');
                //To Close the cost solution table
                this.selectedCostOption = (removeRow.costOption == this.selectedCostOption) ? '' : this.selectedCostOption;
                this.selectedTableIndex = null;
                //After removing a row ,it checks category value for not empty
                this.fieldArray.forEach(data => {
                    if (!data.categoryNo && (data.description || data.solution || data.solType || data.totalCost)) {
                        this.enableSave = false;
                    }
                })
                //after removing row calculating total cost
                this.selectedCost('');
                this.enableSaveonCheck();
            }
            this.confirmDialogRef = null;
        });
    }

    //save soution
    saveSolution() {
        this.titleShow = false;

        if (this.fieldArray.length > 0 && this.pageType === 'requestWorkPage') {
            this.saveData(this.fieldArray)
        }
        else if (this.pageType != 'requestWorkPage') {

            this.bodySpinner = true;
            this.costOptionType = '';

            //Pushing single array if only field array length is zero
            if (this.fieldArray.length == 0) {
                var result;
                var result: any = _.isEqual(this.newAttribute, initialValues)
                if (!result) {
                    //Remove empty object in array before adding new one
                    this.fieldArray = this.fieldArray.filter(value => Object.keys(value).length !== 0);
                    this.fieldArray.push(this.newAttribute);
                    initialValues.searchKeyWords = [];
                    this.newAttribute = Object.assign({}, initialValues);
                }
            }

            this.fieldArray = this.fieldArray.filter(value => Object.keys(value).length !== 0);

            this.fieldArray.forEach(element => {
                if (!element.categoryNo) {
                    this.enableSave = false;
                }
            })

            if (this.enableSave == true) {

                this.enableSave = false

                var randomId = this.pipe.generateNumber();
                //After save solution, if they add another entry means  -> need to update old data no need to create new one

                //Get already report generated with id              
                let reportId = null;
                if (!this.insReportId) {

                    this.formService.CreateInspectionReport(this.currentOrderId, randomId)
                        .then(() => {
                            this.onSubmitFile();
                            this.bookingsQueryService.UPDATE_SCHEDULE_BOOKING_BY_ORDERID(randomId, this.currentOrderId).subscribe(res => {
                                this.onSubmitFile();
                            });

                            //Finally stores data
                            this.storeFinalSolution(randomId, this.fieldArray);
                            reportId = randomId;
                            //create role based user
                            this.solutionFormService.CREATE_SOLUTION_ESTIMATE_USER(this.currentOrderId, reportId).then((result: any) => {
                                this.onSubmitFile();

                                if (result && result.data && result.data.createSolutionestimateuser) {
                                    console.log('result done');
                                } else {
                                    this.toastComponent.showToast(toastMsg.warningForCategory);
                                }
                            }).catch(() => {
                                this.toastComponent.showToast(toastMsg.warningForCategory);
                            });

                        })
                        .catch(() => {
                            this.bodySpinner = false;
                            this.toastComponent.showToast(this.toastMsg.failedReview);
                        })
                } else {
                    this.storeFinalSolution(this.insReportId, this.fieldArray);
                    //call function to sret Role Id of user id
                    reportId = this.insReportId;
                    //create role based user
                    this.solutionFormService.CREATE_SOLUTION_ESTIMATE_USER(this.currentOrderId, reportId).then((result: any) => {
                        this.onSubmitFile();
                        if (result && result.data && result.data.createSolutionestimateuser) {
                            console.log('result done');
                        } else {
                            this.toastComponent.showToast(toastMsg.warningForCategory);
                        }
                    }).catch(() => {
                        this.toastComponent.showToast(toastMsg.warningForCategory);
                        this.bodySpinner = false;
                    });

                }

                // })
            } else {
                this.bodySpinner = false;
                this.enableSave = true;
                this.toastComponent.showToast(toastMsg.warningForCategory);

            }
        }
    }

    saveData(fieldArray) {
        var tempArray = [];
        //save solution in reportreview details

        // check last review Id before saving
        this.solutionFormService.getLastReviewId()
            .then((data: any) => {


                this.lastReviewId = Number.parseInt(data);

                fieldArray.forEach((allElement) => {

                    this.lastReviewId = this.lastReviewId + 1;

                    //Manully enters all itmes ,not in pdf document
                    var checkQueries = this.solutionFormService.CreateSolutionMaster(this.currentOrderId, this.lastReviewId, this.insReportId, allElement.categoryNo, '', allElement, '');

                    checkQueries
                        // .pipe(take(fieldArray.length))
                        .then((response: any) => {
                            this.fieldArray = [];
                            this.selectedCostOption = '';
                            initialValues.searchKeyWords = [];
                            this.newAttribute = Object.assign({}, initialValues);
                            this.selectedTableIndex = null;
                            this.enableSave = false;
                            this.lastReviewId = response && response.data && response.data.createReportReviewDetail && response.data.createReportReviewDetail.reportReviewDetail && response.data.createReportReviewDetail.reportReviewDetail.reviewId ? response.data.createReportReviewDetail.reportReviewDetail.reviewId : null;

                            let report = {
                                orderId: this.currentOrderId,
                                insReportId: this.insReportId,
                                reviewId: this.lastReviewId,
                                accept: true,
                            }


                            //after assign reviewid of reportreview detail to report solution master 
                            this.solutionMasterQueryService.insertReport(report, this.scheduleDateByClient, this.buyerPropertyAddress)
                                .subscribe((response: any) => {
                                }).catch((err) => {
                                    console.log(err);
                                    this.fieldArray = []; //reset array if any error received

                                })

                        }).catch(() => {
                            this.fieldArray = tempArray; //Re assign array if any error received 
                        });


                });
                this.onSubmitFile();


            }).catch(() => {
                this.fieldArray = []; //reset array if any error received
                this.toastComponent.showToast(this.toastMsg.failedReview);
            })

    }

    async storeFinalSolution(insReportId, fieldArray) {

        let checkCount = 0;
        var tempArray = [];

        // check last review Id before saving
        this.formService.getLastReviewId()
            .then((data: any) => {
                this.lastReviewId = Number.parseInt(data);

                fieldArray.forEach((allElement) => {

                    var matchQuery = undefined;

                    this.lastReviewId = this.lastReviewId + 1; //no need add if use UTC

                    //Manully enters all itmes ,not in pdf document
                    var checkQueries = this.formService.CreateSolutionMaster(this.currentOrderId,
                        this.lastReviewId, insReportId,
                        allElement.categoryNo,
                        '',
                        allElement, this.searchKeyWordsList)

                    checkQueries
                        // .pipe(take(fieldArray.length))
                        .then(() => {

                            let savedDetails = {
                                description: allElement.description,
                                totalCost: allElement.totalCost,
                                solution: allElement.solution,
                                // insReportId: category.insReportId,
                                categoryName: allElement.categoryNo,
                                // costOption: category.costOption,
                            };
                            this.auditHistoryCreateFunCall(savedDetails, "Success");

                            ++checkCount;
                            if (checkCount == fieldArray.length) {
                                this.toastComponent.showToast(this.toastMsg.saveEstimateSolution);
                                this.beforeTotalCost = 0;

                                this.formService.insReportIdOfOrder(this.currentOrderId);

                                this.bodySpinner = false;
                                this.fieldArray = [];
                                this.selectedCostOption = '';
                                this.matchedResult = [];
                                initialValues.searchKeyWords = [];
                                this.newAttribute = Object.assign({}, initialValues);
                                this.selectedTableIndex = null;
                                this.enableSave = false;
                                this.lastReviewId = this.lastReviewId;
                                // this.getAllStoredReports();
                            }
                            //prepopulated call after save 
                            this.autoPrePopulatedItems();
                        }).catch(() => {
                            this.bodySpinner = false;
                            tempArray.push(allElement);
                            this.fieldArray = tempArray; //Re assign array if any error received 
                            // this.getAllStoredReports(); //called bottom result function only
                            this.toastComponent.showToast(this.toastMsg.failedReviewSome);

                            let savedDetails = {
                                description: allElement.description,
                                totalCost: allElement.totalCost,
                                solution: allElement.solution,
                                // insReportId: category.insReportId,
                                categoryName: allElement.categoryNo,
                                // costOption: category.costOption,
                            };
                            this.auditHistoryCreateFunCall(savedDetails, "Failed");

                        });
                    // }
                });
            }).catch(() => {
                this.bodySpinner = false;
                this.fieldArray = []; //reset array if any error received
                this.toastComponent.showToast(this.toastMsg.failedReview);
            })

    }

    //Assigning all cost values
    calculatedCostValues(selected: any) {
        _.map(selected, (value, key) => {
            if (this.fieldArray.length == 0) {
                this.newAttribute[key] = value;
                this.selectedCost('');
            }
            else {
                this.fieldArray[this.selectedTableIndex][key] = value;
                this.selectedCost('');
            }
        });
    }

    //Close estimation table
    closeEstimateTable(event: boolean) {
        if (event) {
            this.selectedCostOption = '';
        }
    }

    // set current paginator value -Review reoprts
    getPaginatorForReports(key) {
        this.itemsPerPageForReports = key;
        this.dragIndexChangeForReports();
    }

    // for identifying dragIndex based on paginator value -Review reoprts
    dragIndexChangeForReports() {
        this.dragIndexForReports = (Number(this.itemsPerPageForReports) * (Number(this.pageNumberForReports) - 1))
    }

    //set current page -Review reoprts
    getPageForReports($event) {
        this.pageNumberForReports = $event;
        this.dragIndexChangeForReports();
    }

    //set current page
    getPage($event) {
        this.pageNumber = $event;
        this.dragIndexChange();
    }


    // set current paginator value
    getPaginator(key) {
        this.itemsPerPage = key;
        this.dragIndexChange();
    }

    // for identifying dragIndex based on paginator value
    dragIndexChange() {
        this.dragIndex = (Number(this.itemsPerPage) * (Number(this.pageNumber) - 1))
    }
    //Emit form values to paren component
    onSubmitFile() {
        this.tableLoad.emit({ flag: true });
    }

    cancelWorkRequest() {
        this.confirmDialogRef = this.dialog.open(FuseConfirmDialogComponent, {
            disableClose: false
        });

        this.confirmDialogRef.componentInstance.confirmMessage = this.toastMsg.cancelWorkRequestMessage;
        this.confirmDialogRef.componentInstance.confirmHead = this.toastMsg.deleteCategoryHead;
        this.confirmDialogRef.componentInstance.confirmOkText = this.toastMsg.deleteCategoryOk;
        this.confirmDialogRef.componentInstance.confirmCancelText = this.toastMsg.deleteCategoryCancel;

        this.confirmDialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.ecommerceOrdersService.UpdateRequestStatusFromDropDown(this.nodeId, this.userRole, this.getStatusName(this.cancleWorkConst)).then((response): any => {
                    let statusId = response['data']['updateScheduleRequest']['scheduleRequest'].statusId;
                    this.ecommerceOrdersService.createStatus(this.currentOrderId, statusId, this.userId).then((response: any) => {
                        this.toastComponent.showToast(this.toastMsg.cancelWorkRequest);
                    })

                }).catch((err) => {
                    this.toastComponent.showToast(this.toastMsg.cancelWorkRequestUpdate);
                    console.log(err);
                });
            }
        });
    }

    auditHistoryCreateFunCall(savedDetails, status) {

        let auditLogPayload = {
            roleId: this.roleId,
            userId: this.userId,
            orderId: Number(this.currentOrderId),
            newData: savedDetails,
            oldData: null,
            auditType: "solution_estimate_create",
            logsDesc: "Solution Estimate Created",
            platform: "Executive Dashboard",
            status: status
        };

        this.auditHistoryService.auditHistoryForCreateOrDeleteCall(auditLogPayload);
    }

    getStatusName(data) {
        if (data) {
            let status = this.allStatus.find(type => type.statusName === data);
            return status && status['statusId'] ? status['statusId'] : '';
        }
        else {
            return '';
        }
    }
}

export interface fieldArrayData {
    category: string;
    categorySolution: string;
    solution: string;
    solutionDesc: string;
    totalCost: number;
    imgSrc: string
}

export interface InitialData {
    name: string;
    keyWord?: string;
    categoryNo?: string;
    catagoryType: string;
    categoryId: number;
    subCategoryId: number;
    imagePath: string;
    imageSrc: string
    description: string;
    fullDescription: string;
    approve: string;
    loadSpinner: boolean;
    descSpinner: boolean;
    solType: string;
    solution: string;
    categoryName: string;
    subCategoryName: string;
    totalCost: any;
    hourRate?: number;
    laborHour?: number;
    materialCost?: number;
    labourCost?: number;
    totalTM?: number;
    costOption?: string;
    ni?: number,
    cpi?: number,
    cpf?: number,
    tf?: number
    searchKeyWords?: string[];
    keyPrimCategory?: String,
    keyPhrase?: string,
    key1?: string,
    key2?: string,
    key3?: string,
    key4?: string,
    enableToAddSolution?: boolean
}

const initialValues: InitialData = {
    name: "",
    keyWord: "",
    categoryNo: '',
    catagoryType: '',
    categoryId: 0,
    subCategoryId: 0,
    imagePath: '',
    imageSrc: '',
    description: '',
    fullDescription: '',
    approve: '',
    loadSpinner: false,
    descSpinner: false,
    solType: '',
    solution: '',
    categoryName: '',
    subCategoryName: '',
    totalCost: '',
    hourRate: 0,
    laborHour: 0,
    materialCost: 0,
    labourCost: 0,
    totalTM: 0,
    costOption: '',
    ni: null,
    cpi: null,
    cpf: null,
    tf: null,
    searchKeyWords: [],
    keyPrimCategory: '',
    key1: '',
    keyPhrase: '',
    key2: '',
    key3: '',
    key4: '',
    enableToAddSolution: true
}

const defaultCostInitialValues: DefaultCostValuesModel = {
    labourCost: 0,
    hourRate: 0,
    laborHour: 0,
    totalTM: 0,
    materialCost: 0,
    ni: 0,
    cpi: 0,
    cpf: 0,
    tf: 0,
    laborFinal: 0,
    totalCost: 0
}

export interface OrderStatus {
    statusId: number;
    statusName: string;
    displayStatus: string;
}

const cancelConst = {
    cancleWorkConst: "cancel_work_request"
}




// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/common-save-table/common-save-table.component.ts